module.exports = __webpack_public_path__ + "img/slider_unete.de2ed857.png";